module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedBold.77d4f1f.woff2";